import axios from 'axios';

// Logic:
// 1. If we are in "production" (live on Render), just use "/api".
//    The browser will automatically add the domain for us.
// 2. If we are in "development" (your computer), use "http://localhost:5000/api".

const baseURL = process.env.NODE_ENV === 'production' 
  ? '/api' 
  : 'http://localhost:5000/api';

const api = axios.create({
  baseURL,
});

export default api;